import "./App.min.css";
import Navbar from "./Navbar";
import Header from "./Header";
import MyDemo from "./MyDemo";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <MyDemo />
    </div>
  );
}

export default App;
